import { render, staticRenderFns } from "./EntityCheckboxInput.vue?vue&type=template&id=12a24cb7&"
import script from "./EntityCheckboxInput.vue?vue&type=script&lang=js&"
export * from "./EntityCheckboxInput.vue?vue&type=script&lang=js&"
import style0 from "./EntityCheckboxInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VRow,VSwitch})
